import {useSelector} from 'react-redux';
import {latestNewsSelector} from '../../redux/selectors/news';
import View from './view';

export const NewsScreen = () => {
  const latestNews = useSelector(latestNewsSelector());

  return View({latestNews: latestNews});
};
